import { MenuNode, MenuRoute } from "../../components/menu";
import { LeafRole } from "../../utils/and-or-tree";
import { CancelPage } from "./cancel";
import { names } from "./route-names";
import { SubscriptionPage } from "./subscribe";
import { SuccessPage } from "./success";



const state: MenuRoute[] = [{
    name: names.subscription,
    url: "/subscription",
    component: SubscriptionPage,
    data: {
        title: "Subscription",
        roles: new LeafRole("ROLE_USER"),
    },
}, {
    name: names.success,
    url: "/subscription/success",
    component: SuccessPage,
    data: {
        title: "Subscription Succeeded",
        roles: new LeafRole("ROLE_USER"),
    },
}, {
    name: names.cancel,
    url: "/subscription/cancel",
    component: CancelPage,
    data: {
        title: "Subscription Canceled",
        roles: new LeafRole("ROLE_USER"),
    },
}];

const sidebar: MenuNode.MenuNode = {
    icon: "userProfile",
    route: state[0],
    roles: new LeafRole("ROLE_USER"),
};

export const SubscriptionRoutes = {
    names,
    state,
    sidebar,
};
